const HttpVerbs = {
    post: 'POST',
    put: 'PUT',
    get: 'GET',
    patch: 'PATCH',
    delete: 'DELETE',
};
export default HttpVerbs;

export const HttpVerbsList = Object.values(HttpVerbs);
